import React from "react";

import { ReadOnlyContainer } from "capitalrx-components";

import { TestClaimResponseHeaderFields } from "@/types/appTypes/transmissions";

interface Props {
  headerFields: TestClaimResponseHeaderFields;
}

const ResponseHeaderSegment: React.FC<Props> = (props: Props) => {
  return (
    <div className="response-segment" data-testid="test__response-segment">
      <div className="segment-name" data-testid="test__segment-name">
        Response Header
      </div>
      <div className="row">
        <div className="col">
          <ReadOnlyContainer showLabel label="Transaction Response Status" body={props.headerFields.transactionResponseStatus} />
        </div>
        <div className="col">
          <ReadOnlyContainer showLabel label="Service Provider ID" body={props.headerFields.serviceProviderID} />
        </div>
        <div className="col">
          <ReadOnlyContainer showLabel label="Date of Service" body={props.headerFields.dateOfService} />
        </div>
      </div>
    </div>
  );
};

export default ResponseHeaderSegment;
